import { OPEN_API } from './index';
const endpoints = {
    gameSession: '/game-sessions',
    refreshToken: '/token/refresh',
};
export const startGameSession = async (body) => {
    return await OPEN_API.POST({ endpoint: endpoints.gameSession, body });
};
export const refreshAccessToken = async (token) => {
    return await OPEN_API.POST({ endpoint: endpoints.refreshToken, body: { token } });
};
